import React, { useState, useEffect } from 'react';
import { Thermometer } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const TemperatureWidget = () => {
  const { t } = useLanguage();
  
  const [temperatures, setTemperatures] = useState({
    air: '32',
    water: '29',
    pool: '30'
  });

  useEffect(() => {
    // Fetch weather data from OpenWeatherMap
    const fetchWeather = async () => {
      try {
        // Hua Hin coordinates: 12.57, 99.96
        const API_KEY = process.env.REACT_APP_WEATHER_API_KEY || '8151e5094fbd9106d52a562892dee12b';
        const response = await fetch(
          `https://api.openweathermap.org/data/2.5/weather?lat=12.57&lon=99.96&units=metric&appid=${API_KEY}`
        );
        
        if (response.ok) {
          const data = await response.json();
          const airTemp = Math.round(data.main.temp);
          const waterTemp = Math.round(airTemp * 0.9); // Gulf water slightly cooler
          const poolTemp = Math.round(airTemp * 0.95); // Pool temperature
          
          setTemperatures({
            air: airTemp.toString(),
            water: waterTemp.toString(),
            pool: poolTemp.toString()
          });
        } else {
          console.log('Weather API response not OK, using defaults');
        }
      } catch (error) {
        console.log('Weather API error, using default values:', error);
      }
    };

    fetchWeather();
    // Update every 30 minutes
    const interval = setInterval(fetchWeather, 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="absolute top-28 right-4 bg-white/10 backdrop-blur-sm rounded-xl shadow-lg px-4 py-2 z-10">
      <div className="flex items-center gap-2 text-white text-xs md:text-sm whitespace-nowrap">
        <Thermometer className="w-4 h-4 md:w-5 md:h-5" />
        <span className="font-semibold">{t('temperature.title')}</span>
        <span>{t('temperature.air')}: {temperatures.air}°C</span>
        <span>,</span>
        <span>{t('temperature.water')}: {temperatures.water}°C</span>
        <span>,</span>
        <span>{t('temperature.pool')}: {temperatures.pool}°C</span>
      </div>
    </div>
  );
};

export default TemperatureWidget;
